module.exports = __webpack_public_path__ + "static/media/ice-cream.354d1825.svg";